import http from "../../../core/utils/apis/api";

const getAttendancesReportByTraining= async (trainingId) => {
    try {
        const response = await http({
            method: 'GET',
            url: `/attendances/training-Session/trainings/${trainingId}`,
        });
        return response;
    } catch (e) {
        throw e;
    }
  
  }

  const attendancesReport = {
    getAttendancesReportByTraining,
    
};

export default attendancesReport;